export enum FavoriteType {
  ARTIST = 'artist',
  OFFER = 'offer',
  VENUE = 'venue',
}
